require('./brokerMyInvestmentsWrappedContractsTable.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const BrokerEditAlias = require('components/commons/broker/brokerEditAlias/brokerEditAlias');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const  OKTag = require('components/commons/OKTag/OKTag');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { LoadingDots } = require('commonsComponents/loadingDots');
// @helpers
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const {
    HYPHEN,
    TYPE_OTHERS,
    TYPE_PLANS,
    TYPE_STOCKS,
    TYPE_ETFS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_FUTURES,
    BROKER_TRANSFER_PENSION_PLAN_URL,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    MYPROFILE_BROKER_PENSION_PLAN_BENEFICIARIES_URL,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_ROBO_EDIT_FIELD_FONT,
    TYPE_ALTERNATIVE_FUNDS_PG
} = require('constants/index');
const {
    BRING_MY_FUNDS,
    BRING_MY_FUNDS_INFO_VIEW,
    BROKER_CAMBIOS_COMERCIALIZADORA,
    FUNDS_TRANSFER,
    OPENTRADER,
    BRING_VALUES_TO_OK
} = require('constants/flagBasedFeatures');

// @Contact Center
const WarningMessage = require('components/contactCenter/warningMessage/warningMessage');
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class BrokerMyInvestmentsWrappedContractsTable extends React.Component {
    constructor(props) {
        super(props);
        this.buildHeader = this.buildHeader.bind(this);
        this.getPopoverMenuItems = this.getPopoverMenuItems.bind(this);
        this.handleClickOPAOPV = this.handleClickOPAOPV.bind(this);
        this.handleOrdersAndMovementsClick = this.handleOrdersAndMovementsClick.bind(this);
        this.onPostAlias = this.onPostAlias.bind(this);
        this.handleOpenTraderClick = this.handleOpenTraderClick.bind(this);
    }

    onPostAlias(value) {
        const { contract, contractName, postAlias } = this.props;

        postAlias(contract, value, contractName);
    }

    getContractNumber(contract, contractId, type) {
        let contractNumber;
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_ETFS:
            case TYPE_WARRANTS:
            case TYPE_PLANS:
                contractNumber = contract.get('numerodecontrato');
                break;
            case TYPE_ALTERNATIVE_FUNDS_PG:
            case TYPE_FUNDS:
                contractNumber = contractId;
                break;
            default:
                contractNumber = '';
        }

        return contractNumber;
    }

    getPopoverMenuItems() {
        const { contract, contractId, flagBasedFeatures, type, fundId } = this.props;
        const contractNumber = this.getContractNumber(contract, contractId, type);
        const transferExternalSecuritiesEnabled = flagBasedFeatures.get(BROKER_CAMBIOS_COMERCIALIZADORA);
        const transferCallbackExternalValuesUrl = flagBasedFeatures.get(BRING_VALUES_TO_OK);

        //IMPORTANT!: Item order on this array will give us the positioning of the items for each popOverMenu product
        // If you are attempting to add an item for a specific product here, please make sure to respect the order and double check the menu for other prodcuts as well
        // and verify that the order that are shown is the require one.
        let items = [
            {
                visible: transferCallbackExternalValuesUrl && type !== TYPE_PLANS && type !== TYPE_FUNDS && type !== TYPE_FUTURES,
                link: `/myprofile/broker/callmeBack/externalTransferValues`,
                handleClick: () => this.handleMenuTagging(type, `getMy${type}`),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassValuesToOpenbank')
            },
            {
                visible: transferExternalSecuritiesEnabled && type === TYPE_STOCKS,
                link: `/myprofile/broker/transferValues`,
                handleClick: () => this.handleMenuTagging(type, `TransferBetweenContracts`),
                text: formatText('brokerMyInvestmentsMoreOptions-trasspassValues')
            },
            {
                visible: flagBasedFeatures.get(BRING_MY_FUNDS) && type === TYPE_FUNDS,
                link: flagBasedFeatures.get(BRING_MY_FUNDS_INFO_VIEW) ? '/myprofile/broker/externalTransferFundInfoView' : `/myprofile/broker/externalTransferFund`,
                handleClick: () => this.handleMenuTagging(type, `getMyFunds`),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassFundsToOpenbank')
            },
            {
                visible: type === TYPE_FUNDS && flagBasedFeatures.get(FUNDS_TRANSFER),
                handleClick: () => this.handleInternalTransferFundsClick(fundId, type, `getMyFunds`),
                text: formatText('brokerMyInvestmentsMoreOptions-trasspassFunds')
            },
            {
                visible: type === TYPE_PLANS,
                link: BROKER_TRANSFER_PENSION_PLAN_URL,
                handleClick: () => this.handleMenuTagging(type, 'transferBetweenPlans'),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassBetweenPlanes')
            },
            {
                visible: type === TYPE_PLANS,
                link: `${getPublicSiteUrl()}/simulador-de-aportaciones`,
                externalURL: true,
                handleClick: () => this.handleContributionsSimulatorClick(type, 'contributionsSimulator'),
                text: formatText('brokerMyInvestmentsMoreOptions-PlansContributionsSimulator')
            },
            {
                visible: type === TYPE_PLANS,
                link: `/myprofile/broker/benefitsSimulator`,
                handleClick: () => this.handleMenuTagging(type, 'benefitsSimulator'),
                text: formatText('brokerMyInvestmentsMoreOptions-PlansBenefitsSimulator')
            },
            {
                visible: type === TYPE_STOCKS,
                link: BROKER_CORPORATE_OPERATIONS_URL,
                text: formatText('brokerMyInvestmentsMoreOptions-corporatesOperations')
            },
            /*{
                visible: type === TYPE_STOCKS,
                link: MYPROFILE_BROKER_CALMEBACK_CORPORATES_OPERATIONS,
                text: formatText('brokerMyInvestmentsMoreOptions-OPAOPV'),
                handleClick: () => { this.handleClickOPAOPV(contract.get('numerodecontrato')) }
            },*/
            {
                visible: type === TYPE_STOCKS && flagBasedFeatures.get(OPENTRADER),
                handleClick: () => this.handleOpenTraderClick(type, 'opentrader'),
                text: formatText('brokerMyInvestmentsMoreOptions-opentrader')
            },
            {
                handleClick: () => this.handleOrdersAndMovementsClick(contractNumber, type, 'movementsAndOrders'),
                text: formatText('brokerMyInvestmentsMoreOptions-ordersAndMovements')
            },
            {
                visible:
                    type !== TYPE_PLANS &&
                    type !== TYPE_STOCKS &&
                    type !== TYPE_FUNDS,
                link: `/myprofile/broker/plansInfo`,
                handleClick: () => this.handleMenuTagging(type, 'rescueInformation'),
                text: formatText('brokerMyInvestmentsMoreOptions-plansInfo')
            },
            {
                visible: type === TYPE_STOCKS,
                link: `/myprofile/broker/interveniers/${contractId}/${type}`,
                handleClick: () => this.handleMenuTagging(type, 'seeParticipans'),
                text: formatText('brokerMyInvestmentsMoreOptions-interveniersValuesContract')
            },
            {
                visible: type === TYPE_FUNDS,
                link: `/myprofile/broker/interveniers/${contractId}/${type}`,
                handleClick: () => this.handleMenuTagging(type, 'seeParticipans'),
                text: formatText('brokerMyInvestmentsMoreOptions-interveniers')
            },
            {
                visible: type === TYPE_PLANS,
                link: `${MYPROFILE_BROKER_PENSION_PLAN_BENEFICIARIES_URL}/${contract.get('producto')}/${contract.get('numerodecontrato')}`,
                text: formatText('brokerMyInvestmentsMoreOptions-plansBeneficiaries')
            },
            {
                visible: type === TYPE_PLANS,
                link: MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL,
                handleClick: () => this.handleMenuTagging(type, 'regularContributions'),
                text: formatText('brokerMyInvestmentsMoreOptions-periodicalContributionManagement')
            }
        ];

        return items;
    }

    buildCapitalAmountLabel() {
        const { capital, earnings } = this.props;

        if (this.props.type === TYPE_OTHERS) {
            return HYPHEN;
        } else if (capital == null || earnings == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const capitalValue = capital.get('importe');
            const capitalCurrency = capital.get('moneda');
            const investment = formatWithoutRound(capitalValue, 2);
            const investmentCurrency = formatCurrency(capitalCurrency);
            const investmentFormatted = `${investment} ${investmentCurrency}`;

            return <span>{investmentFormatted}</span>;
        }
    }

    buildHeader() {
        const {
            contractName,
            immBrokerContractState,
            contractId,
            currency,
            accountNumber,
            total,
            interventionType,
            contractForTooltip
        } = this.props;

        const trimmedContractName = trim(contractName);
        const textAndCroppedAccountNumber = (
            <span>
                <span className="broker-contracts-wrap__account-number-label">
                    {formatText('broker-myInvestmentsWrappedContractsTableContractLabel')}
                </span>
                <span className="broker-contracts-wrap__account-number-label">
                    {getLastNChars(accountNumber)}
                </span>
            </span>
        );

        const capitalAmountLabel = this.buildCapitalAmountLabel();
        const profitabilitySection = this.buildProfitabilitySection();

        const actualValue = formatWithoutRound(total || 0, 2);
        const actualValueCurrency = formatCurrency(currency);
        let totalAmount;
        if (!actualValue || !actualValueCurrency) {
            totalAmount = formatText('broker-notAvailableData');
        } else {
            totalAmount = `${actualValue} ${actualValueCurrency}`;
        }
        const contractNameEdit = <BrokerEditAlias alias={trimmedContractName} postAlias={this.onPostAlias} fontSize={BROKER_ROBO_EDIT_FIELD_FONT}/>

        const popoverMenuTarget = <OKIconButton size="small" icon="icon-s-op-comp" />;
        const tooltipContent = this.buildTooltipContent(contractForTooltip);

        let warningAlert;
        if (__CONTACT_CENTER__ && immBrokerContractState) {
            const immContract = immBrokerContractState.getIn(['contracts', `id${contractId}`]);
            if (immContract) {
                const isFetching = immContract.get('isFetching');
                const hasPending = immContract.get('hasPending');
                const numberContract = immContract.get('numberContract');
                const warningLink = `/myprofile/broker/ordersAndMovements/${numberContract}`;

                warningAlert = isFetching ? (<span className="broker-contracts-wrap__header-warning">
                    <LoadingDots inline color="dark" size="medium" />
                </span>) : (hasPending && <span className="broker-contracts-wrap__header-warning">
                    <WarningMessage
                        isLink={true}
                        text={''}
                        to={warningLink}
                        visible={true}
                        typeOfBackground="light"
                    />
                </span>);
            }
        }

        const warningComponent = warningAlert && (
            <OKTooltip
                target={warningAlert}
                content={formatText('brokerContractState-warning')}
                placement="top"
            />
        );
        const interventionLabelText = <FormattedText value="broker-interventionContractType" apiValue={interventionType} />

        return (
            <div className="broker-contracts-wrap__header">
                <div className="broker-contracts-wrap__title">
                    <div>
                        <div className="broker-contracts-wrap__type">
                            {contractNameEdit}
                        </div>
                        <div className="broker-contracts-wrap__intervenier">
                            <OKTag content={interventionLabelText} context="arrow" />
                        </div>
                        {warningComponent}
                    </div>
                    <div className="broker-contracts-wrap__account-number">
                        <OKTooltip
                            target={textAndCroppedAccountNumber}
                            content={tooltipContent}
                            offset={[10,10]}
                            placement="bottom"
                        />
                    </div>
                </div>
                <div className="broker-contracts-wrap__balance row col-xs-6">
                    <span className="broker-contracts-wrap__capital col-xs-4">
                        <span className="broker-contracts-wrap__subtitle">
                            {formatText('broker-myInvestmentsProductsWrapInvestedCapitalLabel')}
                        </span>
                        <span className="broker-contracts-wrap__capital-value">
                            {capitalAmountLabel}
                        </span>
                    </span>
                    {profitabilitySection}
                    <span className="broker-contracts-wrap__total col-xs-3">
                        <span className="broker-products-wrap__subtitle">
                            {formatText('broker-myInvestmentsProductsWrapTotalAmountLabel')}
                        </span>
                        <span className="broker-products-wrap__total-value">
                            {totalAmount}
                        </span>
                    </span>
                    <span className="broker-contracts-wrap__dropdown-menu col-xs-1">
                        <PopoverMenu
                            target={popoverMenuTarget}
                            items={this.getPopoverMenuItems()}
                            placement="bottomRight"
                        />
                    </span>
                </div>
            </div>
        );
    }

    buildProfitability(value, currency, percentage) {
        return (
            <div>
                <span className="broker-contracts-wrap__earnings-value-currency">
                    <span className="broker-contracts-wrap__earnings-value">{value}</span>
                    <span className="broker-contracts-wrap__earnings-currency">{currency}</span>
                    <span className="broker-contracts-wrap__earnings-separator">|</span>
                </span>
                <span className="broker-contracts-wrap__earnings-percentage">{percentage}%</span>
            </div>
        );
    }

    buildProfitabilityLabel() {
        const { earnings, currency, earningsPercentage } = this.props;

        if (earnings === null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        }

        const profitability = formatWithoutRound(earnings, 2);
        const profitabilityPercentage = formatWithoutRound(earningsPercentage, 2);
        const profitabilityCurrency = formatCurrency(currency);

        return this.buildProfitability(profitability, profitabilityCurrency, profitabilityPercentage);
    }

    buildProfitabilitySection() {
        if (this.props.type !== TYPE_FUTURES) {
            const profitabilityLabel = this.buildProfitabilityLabel();

            return (
                <span className="broker-contracts-wrap__earnings col-xs-4">
                    <span className="broker-products-wrap__subtitle">
                        {formatText('broker-myInvestmentsProductsWrapEarningsLabel')}
                    </span>
                    <span className="broker-products-wrap__earnings-value">
                        {profitabilityLabel}
                    </span>
                </span>
            )
        }
    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => this.copyIbanToClipboard(iban)}
                >
                </button>
            </span>
        );
    }

    copyIbanToClipboard(iban) {
        sendTextToClipBoard(iban);
    }

    handleClickOPAOPV(contractNumber) {
        this.props.history.push('/myprofile/broker/corporatesOperations');
        this.props.setOperationContractValue(contractNumber);
    }

    handleMenuTagging(type, tag) {
        taggingEventHandled(this.props.pageName, 'optionsMenu', tag, type);
    }

    handleInternalTransferFundsClick(fundId, type, tag) {
        this.handleMenuTagging(type, tag);
        this.props.onInternalTransferFundsClick(fundId);
        this.props.history.push(MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND);
    }

    handleOpenTraderClick(type, tag) {
        this.handleMenuTagging(type, tag);
        this.props.onOpenTraderClick();
    }

    handleOrdersAndMovementsClick(contractNumber, type, tag) {
        this.handleMenuTagging(type, tag);
        this.props.setOrdersAndMovementsContract(contractNumber);
        this.props.history.push(MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL);
    }

    render() {
        const { children, contractId } = this.props;
        const header = this.buildHeader();

        return (
            <Accordion
                isExpanded={false}
                hasLargeContent={false}
                id={`brokerProduct-stocks-${contractId}`}
                customClassName="broker-contracts-wrap"
            >
                <AccordionHeader name="AccordionHeader">
                    {header}
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {children}
                </AccordionBody>
            </Accordion>
        );
    }
}

BrokerMyInvestmentsWrappedContractsTable.propTypes = {
    children: PropTypes.any,
    contractName: PropTypes.string,
    earnings: PropTypes.number,
    earningsPercentage: PropTypes.number,
    total: PropTypes.number,
    capital: PropTypes.object,
    currency: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    accountNumber: PropTypes.string,
    contractId: PropTypes.string,
    type: PropTypes.string,
    contract: PropTypes.object,
    history: PropTypes.object.isRequired,
    immBrokerContractState: PropTypes.object,
    postAlias: PropTypes.func.isRequired,
    interventionType: PropTypes.string,
    contractForTooltip: PropTypes.string,
    setOperationContractValue: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    fundId: PropTypes.string,
    futureId: PropTypes.string,
    pageName: PropTypes.func
};

module.exports = withFeatureToggling(withRouter(BrokerMyInvestmentsWrappedContractsTable));
